import script from "./AddRoleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddRoleModal.vue?vue&type=script&setup=true&lang=js"

import "./AddRoleModal.vue?vue&type=style&index=0&id=89be1e02&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89be1e02"]])

export default __exports__